import { Validator } from 'jsonschema';
const validator = new Validator();
let errors;
let platform;
export const setPlatform = (value) => {
    errors = [];
    const result = validator.validate(value, {
        $schema: 'http://json-schema.org/draft-04/schema#',
        type: 'string',
        enum: ['browser', 'ios_app', 'android_app'],
    });
    errors.push(...result.errors.map(String));
    platform = value;
};
export const getPlatform = () => platform;
export const resetPlatform = () => {
    platform = null;
    errors = ['No platform has been set'];
};
export const getPlatformErrors = () => errors;
resetPlatform();
